import React from 'react';
import { Link } from 'react-router-dom';
import { AdminNotification } from 'common/AdminNotification';
import useLayoutVisibility from '../hooks/useLayoutVisibility';

/**
 * 사이드바 네비게이션 컴포넌트
 */
function Sidebar() {
  const showLayout = useLayoutVisibility();

  if (!showLayout) return null;

  return (
    <>
      <aside id="sidebar" className="sidebar">
        <ul className="sidebar-nav" id="sidebar-nav">

          {/* Dashboard */}
          <li className="nav-item">
            <Link to="/" className="nav-link">
              <i className="bi bi-grid"></i>
              <span>Dashboard</span>
            </Link>
          </li>

          {/* 상품 메뉴 */}
          <li className="nav-item">
            <Link
              to="#"
              className="nav-link"
              data-bs-target="#product-nav"
              data-bs-toggle="collapse"
              aria-expanded="true"
            >
              <i className="bi bi-product"></i>
              <span data-bs-toggle="tooltip" data-bs-placement="top" title="상품">商品</span>
              <i className="bi bi-chevron-down ms-auto"></i>
            </Link>
            <ul id="product-nav" className="nav-content collapse show" data-bs-parent="#sidebar-nav">
              <li>
                <Link to="/product/list">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="상품목록">商品一覧</span>
                </Link>
              </li>
              <li>
                <Link to="/product/regist">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="상품등록">商品登録</span>
                </Link>
              </li>
              <li>
                <Link to="/product/inventory">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="재고현황">在庫状況</span>
                </Link>
              </li>
            </ul>
          </li>

          {/* 회원 메뉴 */}
          <li className="nav-item">
            <Link
              to="#"
              className="nav-link"
              data-bs-target="#member-nav"
              data-bs-toggle="collapse"
              aria-expanded="true"
            >
              <i className="bi bi-member"></i>
              <span data-bs-toggle="tooltip" data-bs-placement="top" title="유저">会員</span>
              <i className="bi bi-chevron-down ms-auto"></i>
            </Link>
            <ul id="member-nav" className="nav-content collapse show" data-bs-parent="#sidebar-nav">
              <li>
                <Link to="/user/list">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="유저목록">会員一覧</span>
                </Link>
              </li>
              <li>
                <Link to="/user/dealer">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="딜러목록">会員一覧(dealer)</span>
                </Link>
              </li>
              <li>
                <Link to="/user/regist">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="유저등록">会員登録</span>
                </Link>
              </li>
              <li>
                <Link to="/user/attendance">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="유저출석">会員出席チェック</span>
                </Link>
              </li>
            </ul>
          </li>

          {/* 판매 메뉴 */}
          <li className="nav-item">
            <Link
              to="#"
              className="nav-link collapsed"
              data-bs-target="#sales-nav"
              data-bs-toggle="collapse"
              aria-expanded="true"
            >
              <i className="bi bi-sales"></i>
              <span data-bs-toggle="tooltip" data-bs-placement="top" title="판매">取引履歴</span>
              <i className="bi bi-chevron-down ms-auto"></i>
            </Link>
            <ul id="sales-nav" className="nav-content collapse" data-bs-parent="#sidebar-nav">
              <li>
                <Link to="/sales/day">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="일간판매">取引履歴一覧</span>
                </Link>
              </li>
              <li>
                <Link to="/sales/dealer">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="일별판매(딜러)">ディーラー取引履歴一覧</span>
                </Link>
              </li>
              <li>
                <Link to="#">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="입출금이력">入出金履歴</span>
                </Link>
              </li>
              <li>
                <Link to="/manage/cache/arrange">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="정산">精算</span>
                </Link>
              </li>
            </ul>
          </li>

          {/* 기타 기능 */}
          <li className="nav-item">
            <Link
              to="#"
              className="nav-link collapsed"
              data-bs-target="#test-nav"
              data-bs-toggle="collapse"
              aria-expanded="true"
            >
              <i className="bi bi-test"></i>
              <span data-bs-toggle="tooltip" data-bs-placement="top" title="잡다">잡다기능</span>
              <i className="bi bi-chevron-down ms-auto"></i>
            </Link>
            <ul id="test-nav" className="nav-content collapse" data-bs-parent="#sidebar-nav">
              <li>
                <Link to="/pos/review">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="일간판매">pos 보조창</span>
                </Link>
              </li>
              <li>
                <Link to="/barcodeCreate/20231125008">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="바코드 생성">바코드생성</span>
                </Link>
              </li>
              <li>
                <Link to="/attendance">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="출석체크">출석체크</span>
                </Link>
              </li>
            </ul>
          </li>

          {/* 통계 메뉴 */}
          <li className="nav-item">
            <Link
              to="#"
              className="nav-link collapsed"
              data-bs-target="#statistics-nav"
              data-bs-toggle="collapse"
              aria-expanded="false"
            >
              <i className="bi bi-statistics"></i>
              <span data-bs-toggle="tooltip" data-bs-placement="top" title="통계">売上分析</span>
              <i className="bi bi-chevron-down ms-auto"></i>
            </Link>
            <ul id="statistics-nav" className="nav-content collapse show" data-bs-parent="#sidebar-nav">
              <li>
                <Link to="/statistics/daily">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="일별매출">日別売上</span>
                </Link>
              </li>
              <li>
                <Link to="/statistics/monthly">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="월별매출">月別売上</span>
                </Link>
              </li>
              <li>
                <Link to="/statistics/hourly">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="시간대별매출">時間帯別売上</span>
                </Link>
              </li>
              <li>
                <Link to="/statistics/day-of-week">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="요일별매출">曜日別売上</span>
                </Link>
              </li>
              <li>
                <Link to="/statistics/category">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="부문별매출">部門別売上</span>
                </Link>
              </li>
              <li>
                <Link to="/sales/dealer">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="딜러별매출">ディーラー別売上</span>
                </Link>
              </li>
              <li>
                <Link to="/statistics/manufacture/product">
                  <i className="bi bi-circle"></i>
                  <span data-bs-toggle="tooltip" data-bs-placement="top" title="딜러판매정산">딜러판매정산</span>
                </Link>
              </li>
            </ul>
          </li>

          {/* 설정 메뉴 */}
          <li className="nav-item">
            <Link
              to="#"
              className="nav-link collapsed"
              data-bs-target="#setting-nav"
              data-bs-toggle="collapse"
              aria-expanded="true"
            >
              <i className="bi bi-setting"></i>
              <span>설정</span>
              <i className="bi bi-chevron-down ms-auto"></i>
            </Link>
            <ul id="setting-nav" className="nav-content collapse" data-bs-parent="#sidebar-nav">
              <li>
                <Link to="/code/category">
                  <i className="bi bi-circle"></i>
                  <span>상품 카테고리</span>
                </Link>
              </li>
              <li>
                <Link to="/code/member/grade">
                  <i className="bi bi-circle"></i>
                  <span>회원등급</span>
                </Link>
              </li>
            </ul>
          </li>

          {/* 바로가기 */}
          <li className="nav-heading">바로가기</li>

          <li className="nav-item">
            <Link to="/pos" className="nav-link collapsed">
              <i className="bi bi-card-list"></i>
              <span>POS</span>
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/product/inventory" className="nav-link collapsed">
              <i className="bi bi-card-list"></i>
              <span>출석체크</span>
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/logout" className="nav-link collapsed">
              <i className="bi bi-box-arrow-in-right"></i>
              <span>Logout</span>
            </Link>
          </li>

        </ul>
      </aside>

      <AdminNotification />
    </>
  );
}

export default Sidebar;
